import { createContext } from "react";
import usePrecincts from "../hooks/data/usePrecincts";

export interface IPrecinctsContext extends ReturnType<typeof usePrecincts> {

};

const PrecinctsContext = createContext<IPrecinctsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default PrecinctsContext